import React, { useCallback, useEffect, useState } from 'react'
import { plurOrSing, listBlur, listClick } from '../HelperFunctions';
import { AjaxPost } from "../../../Services/index";

export const SupplyListModal = ({ itemsToSupplyList, setItemsToSupplyList }) => {
    const [supplyList, setSupplyList] = useState(productModel.AllSupplyList.length > 1
        ? { "recNo": 'null', "display": "-- All Lists --" }
        : { "recNo": -1, "display": "Create A New List" }
    );
    const [allSupplyLists, setAllSupplyLists] = useState([]);
    const [result, setResult] = useState(null);
    const [loading, setLoading] = useState(false);
    const supplyLists = [];
    var header = "";
    if (!!itemsToSupplyList.length) {
        if (result == null) header = `Add to Supply List: ${itemsToSupplyList.length} ${plurOrSing("Item", itemsToSupplyList.length)}`;
        else if (result === 'Success') header = plurOrSing("Item", itemsToSupplyList.length) + " Added to List";
        else header = "Error adding " + plurOrSing("Item", itemsToSupplyList.length) + " to List";
    }
    else header = "Supply List Notification";

    useEffect(() => setAllSupplyLists([...supplyLists]), [])
    useEffect(() => setLoading(false), [result])
    const escFunction = useCallback((event) => { if (event.key === "Escape") setItemsToSupplyList([]) }, []);
    useEffect(() => {
        document.addEventListener("keydown", escFunction, false);
        return () => document.removeEventListener("keydown", escFunction, false)
    }, [escFunction]);;

    return (<>
        <div className="tw-fixed tw-h-[100%] tw-w-[100%] tw-z-[18] tw-top-0 tw-left-0 tw-z-10" style={{ backgroundColor: "rgba(0,0,0,0.4)" }} aria-labelledby="supplyListModalLabel" onClick={closeModal} />
        <div className="tw-flex tw-fixed tw-flex-col sm:tw-w-[500px] tw-top-0 tw-z-[19] tw-bottom-0 tw-left-0 tw-right-0 tw-m-auto tw-h-fit tw-bg-white">
            <div className="tk-trade-gothic-next tw-text-mine-shaft-950 tw-flex tw-flex-col">
                <div className={"modal-header tw-mx-[24px] tw-pb-[0.5rem] tw-pt-[15px] tw-px-0 " + (itemsToSupplyList.length ? "tw-border-0" : "")} style={{ borderBottom: "1.5px solid #282828" }}>
                    <h5 className="modal-title tw-flex tw-gap-[6px] tw-font-bold tw-text-[21px] sm:tw-text-[24px]">{header}</h5>
                    <div className="close tw-opacity-100 tw-cursor-pointer" aria-label="Close" onClick={() => setItemsToSupplyList([])}>
                        <img src="/Content/img/sprites/close-btn.svg" alt="Close" className="tw-w-[33px]" />
                    </div>
                </div>
                {!itemsToSupplyList.length ? <>
                    <div className="modal-body tw-mx-[20px] tw-pb-[1.5rem]">
                        Please add quantity to an item to add it to your supply list.
                    </div>
                    <div className="tw-self-center tw-mb-[30px] tw-cursor-pointer tw-w-[198px] tw-h-[41px] tw-items-center tw-justify-center tw-uppercase tw-inline-flex tw-bg-tamarillo-700 tw-font-bold tw-text-white hover:tw-bg-tamarillo-650 tw-text-[14px]"
                        onClick={() => setItemsToSupplyList([])}>
                        Continue Shopping
                    </div></>
                    : <>
                        {renderBody()}
                        {renderFooter()}</>
                }
            </div>
        </div></>)

    function closeModal(e) {
        if (e.target !== e.currentTarget) return;
        setItemsToSupplyList([])
    }

    function renderBody() {
        if (result === null) {
            if (productModel.AllSupplyList.length > 1) {
                for (const sl of productModel.AllSupplyList) {
                    supplyLists.push(
                        <div key={sl.Value} className="tw-pb-[10px] md:tw-pb-[3px]"
                            style={(sl.Value === supplyList.recNo) ? { fontWeight: "bold", color: "#A71635" } : {}}
                            onClick={(e) => { setSupplyList({ "recNo": sl.Value, "display": sl.Text }) }}>
                            {sl.Text}
                        </div>
                    );
                }
            }
            supplyLists.push(
                <div key="-1" className="tw-pb-[10px] md:tw-pb-[3px]"
                    style={(-1 === supplyList.recNo) ? { fontWeight: "bold", color: "#A71635" } : {}}
                    onClick={(e) => { setSupplyList({ "recNo": -1, "display": "Create a New List" }) }}>
                    Create A New List
                </div >
            );

            const displayList = itemsToSupplyList.map((uom, i) =>
                <div key={`itemto-supply-${i}`} className="tw-flex tw-flex-col tw-mx-[16px] sm:tw-mx-[26px] tw-items-center">
                    <div className="tw-flex tw-gap-[14px] sm:tw-gap-[20px] tw-py-[14px] sm:tw-pt-0 sm:tw-pb-[5px] sm:tw-px-[10px] tw-w-full"
                        style={i === itemsToSupplyList.length - 1 ? { borderBottom: "none" } : { borderBottom: "1.5px solid #A2A2A2" }}>
                        <div className="tw-flex tw-mt-[16px] tw-flex-[0_0_44%]">
                            <img width="191" src={`/Content/ProductImages/300x225/${uom.ImageName}`} alt="Product image" />
                        </div>
                        <div className="tw-text-[14px] tw-content-center">
                            <div className="tw-text-[#A2A2A2] tw-font-thin">{uom.ItemID}</div>
                            <div className="tw-text-[16px] tw-mb-[8px] tw-font-bold tw-leading-[19px]">{uom.ItemName}</div>
                            <div>Unit of Measure:&nbsp;<span className="tw-font-bold tw-uppercase">
                                {uom.UoM}
                            </span></div>
                            <div>Description:&nbsp;<span className="tw-font-bold tw-uppercase" title={uom.Description?.length > 16 ? uom.Description : ''}>
                                {uom.Description?.length > 16 ? (uom.Description?.substring(0, 16) + '...') : uom.Description ?? 'N/A'}
                            </span></div>
                            <div>Quantity:&nbsp;<span className="tw-font-bold">{uom.displayQty}</span></div>
                        </div>
                    </div>
                </div>
            )

            const listSupplyLists = (
                <div className={"tw-text-right tw-flex tw-flex-col md:tw-gap-[5px] tw-text-mine-shaft-950 tw-items-center tw-justify-end sm:tw-w-[411px] tw-mx-[16px] sm:tw-mx-auto tw-mt-[25px] tw-mb-[22px]"}>
                    <div className="tw-text-[16px] tw-font-bold tw-self-baseline">Select Supply List:&nbsp;</div>
                    <div id="supplylist-drop" className="tw-relative tw-w-full tw-h-[44px] tw-flex tw-items-center tw-justify-around tw-cursor-pointer tw-pl-[10px] tw-pr-[9px]"
                        style={{ border: "solid 1.5px #ACACAC", borderRadius: "3px" }}
                        onClick={() => listClick($("#supplylist-menu"))} onBlur={() => listBlur($("#supplylist-menu"))} tabIndex="0">
                        <div className="tw-flex tw-w-full tw-mb-[2px] md:tw-mb-0 tw-items-center">
                            <span id="supplylist-name" className="tw-font-bold tw-text-[13.5px] sm:tw-text-[14px]">
                                {supplyList.display}
                            </span>
                        </div>
                        <svg id="spinning-svg" className="tw-w-[18px] tw-ml-[2px] tw-mr-[12px] md:tw-mr-0" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                            viewBox="0 0 612 792" style={{ enableBackground: "new 0 0 612 792", transition: "transform .2s" }} xmlSpace="preserve">
                            <g>
                                <rect x="157.3" y="198.5" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -225.0565 249.6209)" style={{ fill: "#A71D37" }} width="63" height="396" />
                                <rect x="226.2" y="365" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -156.1355 416.0993)" style={{ fill: "#A71D37" }} width="396" height="63" />
                            </g>
                        </svg>
                        <div id="supplylist-menu" className="tw-absolute tw-max-h-[200px] tw-overflow-auto tw-left-[-1px] tw-text-[14px] md:tw-text-[16px] md:tw-text-[14px] tw-text-mine-shaft-1000 tw-top-[100%] tw-w-full sm:tw-w-[411px] tw-text-left tw-pl-[21px] md:tw-pl-[13px] tw-pt-[14px] tw-pb-[20px] md:tw-pb-[11px] tw-bg-white tw-z-10 tw-gap-[3px] tw-flex-col tw-cursor-pointer"
                            style={{ border: "solid 1.5px #ACACAC", borderRadius: "3px", boxShadow: "#00000029 0px 3px 6px", display: "none" }}>
                            {allSupplyLists}
                        </div>
                    </div>

                    {supplyList.recNo === -1 && <>
                        <div className="tw-text-[16px] tw-font-bold tw-self-baseline tw-mt-[15px]">Name New Supply List:&nbsp;</div>
                        <input id="supplylist-input" className="tw-w-full tw-h-[44px] tw-flex tw-items-center tw-justify-around tw-pl-[10px] tw-pr-[9px]"
                            style={{ border: "solid 1.5px #ACACAC", borderRadius: "3px" }} /></>
                    }
                </div>
            )
            return (<>
                <div className="tw-max-h-[480px] tw-overflow-auto">{displayList}</div>
                {listSupplyLists}
            </>)
        }
        else if (result === "Success")
            return (
                <div className="tw-text-[16px] tw-mb-[22px] tw-mx-[24px]">
                    You can now manage the items within your Supply Lists. <br /> New Lists can now be shared with other users.
                </div>
            )
        else return (
            <div className="tw-text-[16px] tw-mb-[22px] tw-mx-[24px] tw-text-tamarillo-700">
                An error occured.. <br /> Our tech team has been notified.
            </div>
        )
    }

    function renderFooter() {
        return (
            <div className="modal-footer tw-flex tw-justify-center tw-gap-[15px] tw-border-none tw-pb-[32px] tw-p-0">
                {result === null ?
                    <div onClick={handleAddToList}
                        className={"tw-cursor-pointer tw-mx-[16px] tw-w-full sm:tw-w-[198px] tw-h-[41px] tw-items-center tw-justify-center tw-uppercase tw-inline-flex tw-bg-tamarillo-700 tw-font-bold tw-text-white hover:tw-bg-tamarillo-650 tw-text-[14px] " + (loading ? 'tw-pointer-events-none tw-opacity-40' : '')}>
                        Add To List
                    </div>
                    : <>
                        <div onClick={() => setItemsToSupplyList([])} style={{ border: "1.5px solid #A71636" }}
                            className="tw-cursor-pointer tw-mx-[16px] tw-w-full sm:tw-w-[198px] tw-h-[41px] tw-items-center tw-justify-center tw-uppercase tw-inline-flex tw-font-bold tw-text-[14px] hover:tw-bg-tamarillo-700 hover:tw-text-white">
                            Continue Shopping
                        </div>
                        {result === "Success" &&
                            <div onClick={() => window.location = "/MyAccount/SupplyListUsers"}
                                className="tw-cursor-pointer tw-mx-[16px] tw-w-full sm:tw-w-[198px] tw-h-[41px] tw-items-center tw-justify-center tw-uppercase tw-inline-flex tw-bg-tamarillo-700 tw-font-bold tw-text-white hover:tw-bg-tamarillo-650 tw-text-[14px]">
                                Share List
                            </div>}
                    </>}
            </div>
        )
    }

    function handleAddToList() {
        if (!!$('#supplylist-input').length) {
            //Create new list
            setLoading(true);
            const newListName = $('#supplylist-input').val().toString().trim();
            if (!!newListName) {
                new AjaxPost({
                    type: 'post',
                    endpoint: "/ShoppingCart/CreateSupplyList",
                    payload: JSON.stringify({ SupplyListName: newListName }),
                    cbFunction: (response) => {
                        if (response.split(':')[0] === 'Success') addToList(response.split(':')[2], newListName);
                        else setResult("Error");
                    },
                    errFunction: () => setResult("Error")
                })
            }
            else {
                //No input of new list name
                $('#supplylist-input').css({ "border-color": '#A71635' })
                    .animate({ 'borderWidth': '3px' }, 300)
                    .animate({ 'borderWidth': '1.5px' }, 300)
                    .animate({ 'borderWidth': '3px' }, 300)
                    .animate({ 'borderWidth': '1.5px' }, 300);
                setTimeout(
                    () => {
                        $('#supplylist-input').css({ "border-color": '#ACACAC' });
                        setLoading(false);
                    }, 1200);
            }
        }
        else {
            setLoading(true);
            addToList();
        }
    }

    function addToList(newListRecNo = null, newListName = null) {
        var uomsToAdd = [];
        itemsToSupplyList.forEach(uom => {
            uomsToAdd.push({
                "ItemID": uom.ItemID,
                "DefaultUMDescription": uom.UMDesc,
                "ItemGroupRecNo": uom.ItemGroupRecNo
            });
        })
        new AjaxPost({
            endpoint: '/ShoppingCart/AddItemToSupplyList',
            payload: JSON.stringify(ko.toJS({
                SupplyListRecNo: newListRecNo ? newListRecNo : supplyList.recNo,
                uomsToAdd: uomsToAdd
            })),
            cbFunction: (response) => {
                if (!response) return;
                else if (response.split(':')[0] === 'Success') {
                    if (newListRecNo) productModel.AllSupplyList.splice(productModel.AllSupplyList.length, 0, { "Value": newListRecNo, "Text": newListName });
                    setResult("Success")
                }
                else setResult("Error")
            },
            errFunction: () => setResult("Error")
        });
    }
}